const shuffle = (context: any[]) => {
  const contextCopy = [...context];
  for (let i = contextCopy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [contextCopy[i], contextCopy[j]] = [contextCopy[j], contextCopy[i]];
  }

  return contextCopy;
};

export const generateTemplates = (surveyContext: any, pages: any[]) => {
  const pagesToRender: any[] = [];
  const randomizedContext: any = {};

  pages.forEach((page: any) => {
    if (page.isTemplatePage) {
      const { templateContext, isRandomizedContext } = page;

      const contextToInject = surveyContext.template_context[templateContext];

      if (contextToInject) {
        if (randomizedContext && !randomizedContext[templateContext]) {
          // Randomise context
          randomizedContext[templateContext] = shuffle(contextToInject);
        }

        const contextToIterate = isRandomizedContext
          ? randomizedContext[templateContext]
          : contextToInject;

        const templatePages = contextToIterate.map(
          (context: any, index: number) => {
            const questions = page.elements.map((question: any) => {
              const questionCopy = { ...question };

              for (const key in questionCopy) {
                const value = questionCopy[key];

                if (
                  value &&
                  typeof value === 'string' &&
                  value.includes(`[${templateContext}]`)
                ) {
                  // eslint-disable-next-line
                  // @ts-ignore 
                  questionCopy[key] = value.replaceAll(
                    `[${templateContext}]`,
                    context
                  );
                }

                // RENDER VISIBLE IF FUNC FROM CONTEXT
                if (key === 'visibleIf') {
                  if (questionCopy.renderFromContext) {
                    const { renderFromContext } = questionCopy;
                    const visibleIfFunc = questionCopy.visibleIf;

                    const contextDataToInject =
                      surveyContext.template_context[renderFromContext][
                        context
                      ];

                    if (visibleIfFunc && contextDataToInject) {
                      let funcToInject = '';

                      for (let i = 0; i < contextDataToInject.length; i++) {
                        const copyFunction = visibleIfFunc.slice();
                        const injectedFunction = copyFunction.replaceAll(
                          '[context]',
                          contextDataToInject[i]
                        );

                        if (funcToInject.length < 1) {
                          funcToInject = `(${injectedFunction})`;
                        } else {
                          funcToInject = `${funcToInject} or ${injectedFunction}`; //TODO WE ALWAYS SET OR - rethink how to handle it with other options
                        }
                      }

                      // SETTING UP FUNCTION FOR ELEMENT/QUESTION WITH INJECTED CONTEXT
                      questionCopy.visibleIf = funcToInject;
                    }
                  }
                }

                // MATRIX APPROACH
                if (key === 'rows') {
                  // ROWS GENERATED FROM CONTEXT
                  if (questionCopy.renderFromContext) {
                    const { renderFromContext } = questionCopy;
                    const contextRow = questionCopy.rows[0];

                    const contextDataToInject =
                      surveyContext.template_context[renderFromContext][
                        context
                      ];

                    const dataToInject =
                      contextDataToInject &&
                      contextDataToInject.map((data: string) => {
                        // GENERATE ROWS WITH INJECTED CONTEXT
                        if (contextRow) {
                          const newRow: any = {};

                          for (const key in contextRow) {
                            newRow[key] = contextRow[key]
                              .replaceAll('[context]', data)
                              .replaceAll(`[${templateContext}]`, context);
                          }
                          return newRow;
                        }
                        // NO DEFAULT ROW PROVIDED
                        return {
                          value: data,
                          text: data,
                        };
                      });

                    questionCopy.rows = dataToInject;
                  } else {
                    questionCopy[key] = questionCopy[key].map((data: any) => ({
                      value: data.value.includes(`[${templateContext}]`)
                        ? data.value.replaceAll(`[${templateContext}]`, context)
                        : data.value,
                      text: data.text.includes(`[${templateContext}]`)
                        ? data.text.replaceAll(`[${templateContext}]`, context)
                        : data.text,
                    }));
                  }
                }
              }
              return questionCopy;
            });

            if (
              page.visibleIf &&
              page.visibleIf.includes(`[${templateContext}]`)
            ) {
              return {
                ...page,
                elements: questions,
                name: `${page.name}_${index}`,
                visibleIf: page.visibleIf.replaceAll(
                  `[${templateContext}]`,
                  context
                ),
              };
            }

            return {
              ...page,
              elements: questions,
              name: `${page.name}_${index}`,
            };
          }
        );
        pagesToRender.push(...templatePages);
      }
    } else {
      pagesToRender.push(page);
    }
  });

  return pagesToRender;
};
